export default __webpack_public_path__ + "static/media/ingest-example.df8f56b8.png";